import React from "react";
import "./blog.css";
import Image1 from "../../assets/flyer-1.png";
import Image2 from "../../assets/flyer-2.png";
import Image3 from "../../assets/blog-3.svg";

const blogData = [
  {
    id: 1,
    category: "Lessons",
    image: Image1,
    link: "https://blog.raffifadlika.com/oopjava",
    title: "Memahami OOP dalam Bahasa Java",
    date: "09 October, 2024"
  },
  {
    id: 2,
    category: "Tutorial",
    image: Image2,
    link: "https://blog.raffifadlika.com/laravel-api",
    title: "Tutorial Restfull API with Laravel 11",
    date: "20 October, 2024"
  },
]

const Blog = () => {
  return (
    <section className="blog container section" id="blog">
      <h2 className="section__title">Latest Post</h2>
      <div className="blog__container grid">

        {blogData.map((post) => (
        <div className="blog__card" key={post.id}>
          <div className="blog__thumb">
            <a href={post.link}><span className="blog__category">{post.category}</span></a>
            <a href={post.link}><img src={post.image} alt="" className="blog__img" /></a>
          </div>
          <div className="blog__details">
            <h3 className="blog__title">{post.title}</h3>
            <div className="blog__meta">
              <span>{post.date}</span>
              <span className="blog__dot">.</span>
              <span>Raffi</span>
            </div>
          </div>
        </div>
        ))}
      </div>
    </section>
  )
};

export default Blog;
